import React, { useState, useEffect, useRef } from 'react';
import './Element.css';
// import { EditText, EditTextarea } from "react-edit-text";
import "react-edit-text/dist/index.css";
import { useSelector, useDispatch } from "react-redux";
import { updateGoToSlide, } from '../../redux/slices/userActivity';
import { useLocation, } from "react-router-dom";
import { showDuonutresponse, saveQuizAnsAsync, saveQuizResponse } from '../../redux/slices/DuonutReducer';
import { showduonutData } from '../../redux/slices/DuonutReducer';
import axios from "axios";
import { domain } from "../../services/constants";

const Rating = ({
  id,
  elementAttr,
  elementHoverAttr,
  // conditions,
  language,
  slideId,
}) => {
  const dispatch = useDispatch();
  const { selectedSlide, queSpeechPlaying } = useSelector((state) => state.userActivity);
  const { fontFamily, fontSize, fontWeight, text, fontStyle, textDecoration, textTransform, textAlign, border, color,
    lineHeight, letterSpacing, margin, padding, borderRadius, maxLength, ratingType, backgroundColor, gap, size,
  } = elementAttr;

  const save_ans_response = useSelector(showDuonutresponse);
  const { viewer_display_id, viewer_nick_name, viewer_url_params } = useSelector((state) => state.duonut);
  // const { viewType } = useSelector((state) => state.duonutSettings);
  const location = useLocation();
  const duonutDataMain = useSelector(showduonutData);
  const duonutData = duonutDataMain[0];
  // console.log(duonutData)
  const [inputText, setInputText] = useState("");
  const [isHovered, setIsHovered] = useState(-1);
  const [clickedNum, setClickedNum] = useState(-1);

  const ratingRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [audioUrl, setAudioUrl] = useState(null);
  const [typedText, setTypedText] = useState("");
  const [isTypingDone, setIsTypingDone] = useState(true);

  useEffect(() => {
    if (!inputText || !audioUrl) return;

    // Safely split words including spaces
    const words = inputText.match(/\S+\s*/g)?.filter(Boolean) || [];

    if (words.length === 0) return;

    let index = 0;
    let currentText = "";
    setIsTypingDone(false); // start typing → disable input

    const interval = setInterval(() => {
      if (index < words.length) {
        currentText += words[index]; // safe accumulation
        setTypedText(currentText);
        index++;
      } else {
        clearInterval(interval);
        setIsTypingDone(true); // ✅ Typing complete → enable input
      }
    }, 300);

    return () => clearInterval(interval);
  }, [inputText, audioUrl]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.5 } // 50% of the div must be visible
    );

    if (ratingRef.current) {
      observer.observe(ratingRef.current);
    }

    return () => {
      if (ratingRef.current) {
        observer.unobserve(ratingRef.current);
      }
    };
  }, [inputText]);

  useEffect(() => {
    if (isVisible && inputText && queSpeechPlaying && duonutData?.setting?.question_speech && location.pathname.includes("/duonut/") && slideId === `slide-${selectedSlide}`) {
      fetchAudio(inputText);
    } else {
      setAudioUrl(null);
    }
  }, [isVisible, inputText, queSpeechPlaying]);

  useEffect(() => {
    if (location.pathname.includes("/duonut/") && slideId === `slide-${selectedSlide}` && language !== "en") {
      fetchText(text);
    } else {
      setInputText(text);
    }
  }, [text]);

  const fetchText = async (texts) => {
    const t_text = await translateText(texts, language);
    setInputText(t_text);
  };
  const translateText = async (texts, targetLanguage) => {
    try {
      const response = await axios({
        method: "POST",
        url: `${domain}/duonut/language_translator`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          source: "en",
          target: targetLanguage,
          query: texts,
        },
      });

      if (response.status === 200) {
        // console.log("Translation:", response);
        return response?.data.translation; // return the translated text
      } else {
        // Handle unsuccessful status codes
        return "Error: Translation failed. Please try again.";
      }
    } catch (error) {
      console.error('Error in translation API:', error);
      return "Error translating text. Please try again."; // Handle API errors gracefully
    }
  };

  const fetchAudio = async (texts) => {
    const response = await fetch(`${domain}/duonut/get_speech`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ question_text: texts }),
    });

    const data = await response.json();
    if (data.audio_base64) {
      const audioSrc = `data:audio/mp3;base64,${data.audio_base64}`;
      setAudioUrl(audioSrc);
    }
  };


  const handleButtonClick = (num) => {
    if (location.pathname.includes("/duonut/")) {
      setIsVisible(false);
      setTypedText("");
      setClickedNum(num);

      var save_ans = {
        display_id: viewer_display_id,
        watch_id: save_ans_response[0] ? save_ans_response[0].watch_id : "",
        result: 0,
        question: text ? text : "",
        answered_text: num + 1,
        // end: lastQue ? "1" : "0",
        nickname: viewer_nick_name,
        step: selectedSlide + 1,
        type: "Rating",
        // country: location[0] ? location[0].address?.country : "",
        // city: location[0] ? location[0].address?.state_district : "",
        // location: location[0] ? location[0].display_name : "",
        url_params: viewer_url_params,
      }
      // console.log(save_ans);
      const formData = new FormData();
      Object.keys(save_ans).forEach(key => {
        const value = typeof save_ans[key] === "object" ? JSON.stringify(save_ans[key]) : save_ans[key];
        formData.append(key, value);
      });

      dispatch(saveQuizAnsAsync(formData));

      var save_response = {
        type: "Rating",
        step: selectedSlide + 1,
        question: text ? text : "",
        answered_text: num + 1,
      }
      dispatch(saveQuizResponse(save_response));

      var nextPage = selectedSlide + 1;
      duonutData?.user_activity[selectedSlide]?.condition?.map(node => {
        if (node.condition.length === 2) {
          if ((node.condition[0] === "equal to" && num + 1 === parseInt(node.condition[1])) ||
            (node.condition[0] === "not equal to" && num + 1 !== parseInt(node.condition[1])) ||
            (node.condition[0] === "lower than" && num + 1 < parseInt(node.condition[1])) ||
            (node.condition[0] === "greater than" && num + 1 > parseInt(node.condition[1])) ||
            (node.condition[0] === "lower or equal to" && num + 1 <= parseInt(node.condition[1])) ||
            (node.condition[0] === "greater or equal to" && num + 1 >= parseInt(node.condition[1]))) {
            nextPage = node.target - 1;
          }
        } else if (node.always) {
          nextPage = node.target - 1;
        }
      })

      setTimeout(() => {
        dispatch(updateGoToSlide(nextPage));
      }, 1000);
    }
  }

  return (
    <div ref={ratingRef} >
      {(audioUrl || !duonutData?.setting?.question_speech || !queSpeechPlaying) ?
        <>
          {audioUrl && (
            <audio autoPlay style={{ display: "none" }}>
              <source src={audioUrl} type="audio/mp3" />
              Your browser does not support the audio element.
            </audio>
          )}
          <div style={{
            display: "flex", justifyContent: "center", alignItems: "center", flexDirection: 'column',
            border: border ? border : "0", margin, padding, borderRadius, gap: gap
          }} >
            <div
              style={{
                width: "100%", paddingBottom: '8px',
                color, fontFamily, fontSize, fontWeight, fontStyle, textDecoration, textTransform,
                textAlign, lineHeight, letterSpacing,
              }}>{(duonutData?.setting?.question_speech && queSpeechPlaying && location.pathname.includes("/duonut/")) ? typedText : inputText}</div>

            <div style={{
              width: "100%",
              display: "flex",
              justifyContent:
                textAlign === "center"
                  ? "center"
                  : textAlign === "right"
                    ? "flex-end"
                    : "flex-start", alignItems: "center"
            }}>
              {isTypingDone && Array.from({ length: maxLength }, (_, i) => {
                return <>{ratingType === "star" && <svg viewBox="0 0 62 58" key={i}
                  style={{ width: `${size}px`, height: `${size}px`, paddingRight: "5px" }}
                  onMouseEnter={() => setIsHovered(i + 1)}
                  onMouseLeave={() => setIsHovered(-1)}
                  onClick={() => handleButtonClick(i)}>
                  <path className="symbolFill" style={{ fill: isHovered < (i + 1) ? clickedNum < i ? backgroundColor : elementHoverAttr?.selectedBackgroundColor : elementHoverAttr?.backgroundColor }} d="M31 44.237L12.19 57.889l7.172-22.108L.566 22.111l23.241-.01L31 0l7.193 22.1 23.24.011-18.795 13.67 7.171 22.108z" fill-rule="evenodd"></path>
                  <path className="symbolOutline" style={{ fill: isHovered < (i + 1) ? clickedNum < i ? backgroundColor : elementHoverAttr?.selectedBackgroundColor : elementHoverAttr?.backgroundColor }} d="M31 41.148l14.06 10.205-5.36-16.526 14.051-10.22-17.374-.008L31 8.08l-5.377 16.52-17.374.009L22.3 34.827l-5.36 16.526L31 41.148zm0 3.089L12.19 57.889l7.172-22.108L.566 22.111l23.241-.01L31 0l7.193 22.1 23.24.011-18.795 13.67 7.171 22.108L31 44.237z" fill-rule="nonzero"></path>
                </svg>}
                  {ratingType === "heart" && <svg viewBox="0 0 32 32" key={i}
                    style={{ width: `${size}px`, height: `${size}px`, paddingRight: "5px" }}
                    onMouseEnter={() => setIsHovered(i + 1)}
                    onMouseLeave={() => setIsHovered(-1)}
                    onClick={() => handleButtonClick(i)}>
                    <path className="symbolFill" style={{ fill: isHovered < (i + 1) ? clickedNum < i ? backgroundColor : elementHoverAttr?.selectedBackgroundColor : elementHoverAttr?.backgroundColor }} d="M0 8.313q0-.125.016-.234t.016-.203V7.47q.156-1.594.844-2.922t1.875-2.391Q3.939 1.063 5.329.532T8.313.001q1.281 0 2.453.344t2.203 1.063q1.031.688 1.797 1.609T16 5.095q.5-1.156 1.25-2.078t1.781-1.609Q20.094.689 21.25.345t2.438-.344q1.594 0 2.984.531t2.578 1.625q1.219 1.063 1.891 2.391t.828 2.922q.031.094.031.203v.641q0 1.031-.172 2.047t-.516 1.984-.797 1.844-1.047 1.688q-.594.781-1.25 1.547t-1.375 1.516q-.719.719-1.469 1.438t-1.563 1.406-1.578 1.359-1.484 1.328q-.719.625-1.406 1.297t-1.313 1.391q-.344.375-.641.734t-.547.703-.453.688-.391.656q-.344-.656-.844-1.359t-1.156-1.422q-.625-.719-1.313-1.406t-1.438-1.313q-.719-.625-1.469-1.281t-1.563-1.344q-.813-.719-1.578-1.438t-1.484-1.438q-.719-.75-1.375-1.516t-1.25-1.547q-.563-.813-1.016-1.703t-.797-1.859q-.188-.5-.313-.984t-.219-.984T.042 9.33t-.047-1.016z"></path>
                    <path className="symbolOutline" style={{ fill: isHovered < (i + 1) ? clickedNum < i ? backgroundColor : elementHoverAttr?.selectedBackgroundColor : elementHoverAttr?.backgroundColor }} d="M0 8.313q0-.125.016-.234t.016-.203V7.47q.156-1.594.844-2.922t1.875-2.391Q3.939 1.063 5.329.532T8.313.001q1.281 0 2.453.344t2.203 1.063q1.031.688 1.797 1.609T16 5.095q.5-1.156 1.25-2.078t1.781-1.609Q20.094.689 21.25.345t2.438-.344q1.594 0 2.984.531t2.578 1.625q1.219 1.063 1.891 2.391t.828 2.922q.031.094.031.203v.641q0 1.031-.172 2.047t-.516 1.984-.797 1.844-1.047 1.688q-.594.781-1.25 1.547t-1.375 1.516q-.719.719-1.469 1.438t-1.563 1.406-1.578 1.359-1.484 1.328q-.719.625-1.406 1.297t-1.313 1.391q-.344.375-.641.734t-.547.703-.453.688-.391.656q-.344-.656-.844-1.359t-1.156-1.422q-.625-.719-1.313-1.406t-1.438-1.313q-.719-.625-1.469-1.281t-1.563-1.344q-.813-.719-1.578-1.438t-1.484-1.438q-.719-.75-1.375-1.516t-1.25-1.547q-.563-.813-1.016-1.703t-.797-1.859q-.188-.5-.313-.984t-.219-.984T.042 9.33t-.047-1.016zm1.281 0q0 1.031.203 2.031t.578 1.969q.406.969.906 1.844t1.094 1.625q.625.75 1.344 1.516t1.531 1.578 1.625 1.531 1.594 1.375q.781.625 1.563 1.344t1.594 1.531q.844.781 1.516 1.531t1.172 1.438q.531-.688 1.203-1.438t1.484-1.531q.813-.813 1.609-1.531t1.578-1.344q.781-.656 1.578-1.375t1.609-1.531q.844-.813 1.563-1.578t1.313-1.516q.625-.75 1.125-1.625t.875-1.844q.406-.969.594-1.969t.188-2.031v-.547l-.031-.141q-.125-1.375-.703-2.5t-1.578-2.031-2.172-1.359-2.547-.453q-1.094 0-2.078.297t-1.859.891-1.516 1.375-1.047 1.75q-.188.469-.484 1.172t-.703 1.641q-.125-.344-.422-1.047t-.766-1.766q-.375-.969-1.016-1.75T12.251 2.47q-.875-.594-1.859-.891t-2.078-.297q-1.344 0-2.531.453T3.595 3.094 2.032 5.125t-.719 2.5v.141l-.031.172v.375z"></path>
                  </svg>}
                  {ratingType === "thumb" && <svg viewBox="0 0 32 32" key={i}
                    style={{ width: `${size}px`, height: `${size}px`, paddingRight: "5px" }}
                    onMouseEnter={() => setIsHovered(i + 1)}
                    onMouseLeave={() => setIsHovered(-1)}
                    onClick={() => handleButtonClick(i)}>
                    <path className="symbolFill" style={{ fill: isHovered < (i + 1) ? clickedNum < i ? backgroundColor : elementHoverAttr?.selectedBackgroundColor : elementHoverAttr?.backgroundColor }} d="M0 30.063V17.907q0-.281.094-.5t.281-.406.422-.281.484-.094h3.844q.281 0 .5.094t.406.281.281.406.094.5v12.156q0 .281-.094.516t-.281.422-.406.266-.5.078H1.281q-.25 0-.484-.078t-.422-.266-.281-.422T0 30.063zm7.688.343V17.281h.625q.219 0 .438-.078t.438-.234q.25-.188.516-.453t.578-.609q.313-.375.656-.938t.719-1.281q.375-.75.766-1.625t.797-1.906q.094-.219.219-.438t.281-.406q.188-.219.328-.375t.266-.25l.141-.141.172-.141q.125-.094.234-.172t.234-.172q.375-.313.688-.625t.531-.656q.25-.375.484-.953t.422-1.359q.094-.375.188-.828t.156-.953q.063-.531.109-1.094t.078-1.188q0-.188.156-.281T18.377 0q.063-.031.109-.031h.078q.281 0 .594.078t.688.234q.219.094.406.203t.344.266q.188.125.359.297t.297.359q.375.5.578 1.156t.266 1.5q.016.281.016.563 0 .547-.078 1.063-.125.781-.438 1.5-.031.063-.219.469t-.563 1.125q-.375.688-.625 1.297t-.406 1.109q-.063.25-.094.484t-.031.422.047.344.109.313q1.813-.094 3.25-.109h.563q1.094 0 1.938.047 1.094.031 1.797.125t1.047.25q.344.125.703.469t.734.906q.375.531.547.984t.141.828q0 .125-.125.359t-.375.578q-.25.313-.391.531t-.172.344q0 .188.125.5t.375.75q.281.438.438.75t.156.469-.172.422-.516.672q-.344.375-.516.625t-.172.406.078.453.234.734q.188.438.266.734t.078.453q0 .25-.203.594t-.609.75-.641.656-.297.344q-.031.125-.047.375t-.016.625-.016.625-.047.375q-.125.281-.406.609t-.719.703-.797.625-.672.344q-.594.188-1.563.266T21.468 32t-2.609-.031-2.328-.125l-.875-.078-1.25-.109q-.844-.156-2.516-.469t-4.203-.781z"></path>
                    <path className="symbolOutline" style={{ fill: isHovered < (i + 1) ? clickedNum < i ? backgroundColor : elementHoverAttr?.selectedBackgroundColor : elementHoverAttr?.backgroundColor }} d="M0 30.063V17.907q0-.281.094-.5t.281-.406.422-.281.484-.094h3.844q.281 0 .5.094t.406.281.281.406.094.5v12.156q0 .281-.094.516t-.281.422-.406.266-.5.078H1.281q-.25 0-.484-.078t-.422-.266-.281-.422T0 30.063zm1.281 0h3.844V17.907H1.281v12.156zm6.407.343V17.281h.625q.219 0 .438-.078t.438-.234q.25-.188.516-.453t.578-.609q.313-.375.656-.938t.719-1.281q.375-.75.766-1.625t.797-1.906q.094-.219.219-.438t.281-.406q.188-.219.328-.375t.266-.25l.141-.141.172-.141q.125-.094.234-.172t.234-.172q.375-.313.688-.625t.531-.656q.25-.375.484-.953t.422-1.359q.094-.375.188-.828t.156-.953q.063-.531.109-1.094t.078-1.188q0-.188.156-.281T18.377 0q.063-.031.109-.031h.078q.281 0 .594.078t.688.234q.219.094.406.203t.344.266q.188.125.359.297t.297.359q.375.5.578 1.156t.266 1.5q.016.281.016.563 0 .547-.078 1.063-.125.781-.438 1.5-.031.063-.219.469t-.563 1.125q-.375.688-.625 1.297t-.406 1.109q-.063.25-.094.484t-.031.422.047.344.109.313q1.813-.094 3.25-.109h.563q1.094 0 1.938.047 1.094.031 1.797.125t1.047.25q.344.125.703.469t.734.906q.375.531.547.984t.141.828q0 .125-.125.359t-.375.578q-.25.313-.391.531t-.172.344q0 .188.125.5t.375.75q.281.438.438.75t.156.469-.172.422-.516.672q-.344.375-.516.625t-.172.406.078.453.234.734q.188.438.266.734t.078.453q0 .25-.203.594t-.609.75-.641.656-.297.344q-.031.125-.047.375t-.016.625-.016.625-.047.375q-.125.281-.406.609t-.719.703-.797.625-.672.344q-.594.188-1.563.266T21.468 32t-2.609-.031-2.328-.125l-.875-.078-1.25-.109q-.844-.156-2.516-.469t-4.203-.781zm1.281-1.062q.688.125 2.078.391t3.484.641h10.594q.219-.094.453-.281t.516-.438.453-.453.234-.359l-.016-.047-.016-.141-.016-.25-.016-.375q0-.188.016-.359t.047-.328.078-.297.109-.266q.094-.188.313-.438t.531-.594q.344-.313.531-.516t.219-.266q0-.031-.063-.188t-.188-.406q-.125-.281-.219-.703t-.188-.953v-.156q.031-.125.047-.234t.047-.234.078-.219.109-.188q.063-.125.141-.234t.172-.234.203-.25.234-.25l.156-.156q.063-.063.078-.094l.016-.031q0-.031-.047-.109t-.141-.172q-.063-.094-.109-.188t-.109-.188-.141-.234-.172-.359l-.141-.484q-.078-.265-.141-.547v-.25q.031-.063.047-.125t.016-.094q.031-.063.047-.125t.016-.125q.125-.313.25-.547t.25-.359q.125-.156.234-.25t.203-.094v-.109l-.031-.047q-.063-.25-.156-.453t-.219-.391-.297-.375-.359-.344q0-.031-.016-.047l-.016-.016q0-.031-.016-.031h-.047q-.031-.031-.047-.063t-.047-.031q0-.031-.016-.047t-.047-.016q-.125-.063-.484-.109t-.953-.078q-.563-.031-1.328-.047t-1.766-.016h-.938l-.906.031h-.859l-.859.031q-.188-.094-.469-.25t-.688-.375q-.031-.094-.063-.172t-.063-.172l-.063-.188-.063-.156q0-.094-.016-.172t-.047-.141v-.313q0-.438.094-.906t.281-.969q.188-.531.438-1.078t.563-1.109q.156-.281.266-.516t.203-.391q.094-.188.141-.297t.047-.141q.125-.281.203-.547t.141-.516q.063-.281.078-.563t.016-.594q0-.375-.031-.719t-.125-.625q-.063-.281-.188-.531t-.281-.438q-.094-.156-.234-.281t-.297-.219q-.156-.125-.328-.203t-.391-.109q-.125 1.688-.391 2.953t-.641 2.109q-.375.813-.891 1.484t-1.172 1.203q-.313.219-.547.422t-.422.391q-.156.188-.281.375t-.188.344q-.688 1.75-1.391 3.125t-1.391 2.375q-.656.969-1.328 1.563t-1.359.781v10.875zm19.594-4.313q.031-.031.031-.047v-.078l-.016.016-.016.047v.063zm.625-4.593l.063.125h.031v-.094q.031-.063.031-.109v-.047l-.031.031zm.125-.157z"></path>
                  </svg>}
                  {ratingType === "correct" && <svg viewBox="0 0 58 47" key={i}
                    style={{ width: `${size}px`, height: `${size}px`, paddingRight: "5px" }}
                    onMouseEnter={() => setIsHovered(i + 1)}
                    onMouseLeave={() => setIsHovered(-1)}
                    onClick={() => handleButtonClick(i)}>
                    <path className="symbolFill" style={{ fill: isHovered < (i + 1) ? clickedNum < i ? backgroundColor : elementHoverAttr?.selectedBackgroundColor : elementHoverAttr?.backgroundColor }} d="M21 27.1L48.05.05l9.9 9.9L21 46.9.05 25.95l9.9-9.9z" fill-rule="nonzero"></path>
                    <path className="symbolOutline" style={{ fill: isHovered < (i + 1) ? clickedNum < i ? backgroundColor : elementHoverAttr?.selectedBackgroundColor : elementHoverAttr?.backgroundColor }} d="M21 30.636L9.95 19.586 3.586 25.95 21 43.364 54.414 9.95 48.05 3.586 21 30.636zM48.05.05l9.9 9.9L21 46.9.05 25.95l9.9-9.9L21 27.1 48.05.05z" fill-rule="nonzero"></path>
                  </svg>}

                </>
              })}
            </div>
          </div>
        </> : <div style={{ display: "flex", justifyContent: "center" }}><img alt="loader" src={require(`../../assets/Images/dot_loading.gif`)} /></div>}
    </div>
  );
}

export default Rating;
